import React from "react";
import "./CatchReview.scss";
import { Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { uomToDisplay } from "../../constants/vtrTrip";
import { useSelector } from "react-redux";

const CatchReview = (props) => {
  const { uomCodes = [], reportTripType = [] } = useSelector(
    (state) => state.validation.validations
  );
  let allCatches = [];
  if (
    props.catch_array &&
    Array.isArray(props.catch_array) &&
    props.catch_array.length > 0 &&
    props.catch_array[0].hasOwnProperty("species")
  ) {
    allCatches = props.catch_array;
  }
  if (allCatches.length === 0) {
    return null;
  }

  return allCatches.map(function (d, idx) {
    return (
      <div key={"catch_" + idx} className="margTop10">
        <Button
          component={Link}
          to={`${process.env.PUBLIC_URL}/vtr-catch`}
          state={{
            trip_id: props.trip_id,
            client_id: props.client_id,
            effortNr: props.effortNr,
            catchNr: idx,
            types: reportTripType,
          }}
          style={{
            width: "310px",
            minWidth: "50vw",
            maxWidth: "75vw",
            backgroundColor: "lightgray",
          }}
        >
          <Grid container direction={"column"}>
            <Grid item>
              <h3
                style={{
                  borderBottom: "solid 1px #3f51b5",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                Catch {idx + 1}
              </h3>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                Species:
              </Grid>
              <Grid item xs={7}>
                {d.species}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                Kept:
              </Grid>
              <Grid item xs={7}>
                {d.kept}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                Discarded:
              </Grid>
              <Grid item xs={7}>
                {d.discarded}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                UOM:
              </Grid>
              <Grid item xs={7}>
                {uomToDisplay(d.uom, uomCodes)}
              </Grid>
            </Grid>
          </Grid>
        </Button>
      </div>
    );
  });
};

export default CatchReview;
